"use client";

import { c as _c } from "react/compiler-runtime";
import LoadingFallback from "@/components/layout/loading-fallback";
import { Iphone15Pro } from "@/components/magicui/iphone-15-pro";
import dynamic from "next/dynamic";
import { SectionContentCard, SectionWrapper } from "../section-structure";
const NewsletterForm = dynamic(() => import("../newsletter-form"), {
  ssr: false,
  loading: () => <LoadingFallback />
});
type NewsletterCTASectionProps = {
  title: string;
  description: string;
};
export default function NewsletterCTASection(t0) {
  const $ = _c(11);
  const {
    title,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative mx-auto hidden h-72 w-full overflow-hidden md:block md:h-full"><div className="absolute inset-0 flex translate-y-10 cursor-pointer items-start justify-center transition md:translate-y-12 md:hover:translate-y-8"><Iphone15Pro src="/images/other/newsletter-header-image.png" /></div></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <h4 className="text-3xl font-semibold tracking-tight md:text-4xl">{title}</h4>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <p className="text-lg tracking-wide">{description}</p>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="prose dark:prose-invert">{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <NewsletterForm />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <SectionWrapper className="max-w-5xl"><SectionContentCard className="grid grid-cols-1 gap-8 py-0 md:grid-cols-2">{t1}<div className="py-8 md:py-12">{t4}{t5}</div></SectionContentCard></SectionWrapper>;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}